import { render, staticRenderFns } from "./returnOrderReceipt.vue?vue&type=template&id=db381ec8&"
import script from "./returnOrderReceipt.vue?vue&type=script&lang=ts&"
export * from "./returnOrderReceipt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports